import SalesOrderInterface from '@/interfaces/SalesOrderInterface';
import SalesOrderLineInterface from '@/interfaces/SalesOrderLineInterface';

export default class SalesOrder implements SalesOrderInterface {
  constructor(data: Partial<SalesOrderInterface> = {}) {
    Object.assign(this, data);
  }
  messages: string[] = [];
  No: string = '';
  Sell_to_Customer_No: string = '';
  Sell_to_Customer_Name: string = '';
  Order_Date: string = '';
  Shipment_Date: string = '';
  Ship_to_Name: string = '';
  Ship_to_Address: string = '';
  Ship_to_Address_2: string = '';
  Ship_to_City: string = '';
  Ship_to_County: string = '';
  Ship_to_Post_Code: string = '';
  Ship_to_Country_Region_Code: string = '';
  Ship_to_Contact: string = '';
  Ship_to_Email: string = '';
  Ship_to_Phone_No: string = '';
  Sell_to_Contact_No: string = '';
  Sell_to_Address: string = '';
  Sell_to_City: string = '';
  Sell_to_County: string = '';
  Sell_to_Post_Code: string = '';
  Sell_to_Contact: string = '';
  Sell_to_Name: string = '';
  Sell_to_Address2: string = '';
  Sell_to_Country: string = '';
  Sell_to_Address_2: string = '';
  No_of_Cases: number = 0;
  Document_Date: string = '';
  Due_Date: string = '';
  Status: string = '';
  Order_Type: string = '';
  Order_Classification: string = '';
  SS_Shipment_Date: string = '';
  Picked_Date: string = '';
  Deferred_Shipment: boolean = false;
  Deferral_Date: string = '';
  Shipping_Agent_Code: string = '';
  Shipping_Agent_Service_Code: string = '';
  Bill_to_Name: string = '';
  Bill_to_Address: string = '';
  Bill_to_City: string = '';
  Bill_to_County: string = '';
  Bill_to_Post_Code: string = '';
  Bill_to_Contact: string = '';
  Bill_to_Contact_No: string = '';
  No_of_Parcels: number = 0;
  Document_Type: string = '';
  No_of_Garments: string = '';
  Shipment_Status: string = '';
  Package_Tracking_No: string = '';
  Digitiser_Vectorising_Case: string = '';
  Your_Reference: string = '';
  Document_Cancelled: boolean = false;
  No_of_Packages: number = 0;
  Digitiser_Status: string = '';
  Consumer_Order_Reference: string = '';
  OrderNotes: string = '';
  Commercial_Invoice: boolean = false;
  Warehouse_Process_Status: string = '';
  Item_Charge_Misisng: number = 0;
  Customs_Reason_For_Export: string = '';
  Customs_Notes: string = '';
  Customs_Unit_Value_Currency: string = '';
  Customs_Currency_Rate: string = '';
  Customs_Sender_Eori: string = '';
  Customs_Delivery_Eori: string = '';
  Customs_Delivery_Pid: string = '';
  Customs_Delivery_Vat_No: string = '';
  Customs_Sender_Vat_No: string = '';
  Customs_Sender_IOSS_No: string = '';
  Terms_of_Sales: string = '';
  Deferred_Shipping_Agent_Code: string = '';
  Deferred_Shipping_Agent_Service_Code: string = '';
  No_of_New_Boxes: string = '';
  hasPrint: boolean = false;
  Print_Created_Date: string = '';
  Despatch_Note: boolean = false;
  PrePick_PO_Number: string = '';
  Dispatch_Note_URL: string = '';
  Notes_Available: string = '';
  SalesLines: { Sales_Order_Line: Array<SalesOrderLineInterface> } = { Sales_Order_Line: [] };
  metrics: { time: string } = { time: '' };
  Open_Hold: boolean = false;
  Reference: string = '';
}
